module.exports = __webpack_public_path__ + "img/RegenInBergen.d4d8f16a.jpg";